import React from "react";
import { Box } from "@mui/material";
import HeroSection from "../components/ApplyMain/HeroSection";
import Courses from "../components/ApplyMain/Courses";

const useStyles = () => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    overflow: "hidden",
  },
});

const JavaScriptBootcamp = () => {
  const classes = useStyles();

  return (
    <>
      <Box sx={classes.container}>
        <HeroSection />
        <Courses />
      </Box>
    </>
  );
};

export default JavaScriptBootcamp;
